import { useState, useEffect } from "react";
import { useRouter } from 'next/router'
import dynamic from "next/dynamic";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { hasProperty, isEmpty } from "../../../utils/validate";
import { getFormAttribute } from "../../../utils/forms/forms.util";

const FormBuilder = dynamic(() => import("../../Shared/FormBuilder"));

const BATDForm = (props) => {
	const {
		// formTitle,
		submitFormData,
		category,
		formData,
		carModel,
		carModels,
		spec,
		thankYou
	} = props;

	const submitData = (success) => {
		if (success) {
			submitFormData();
		} else {
			alert("oops");
		}
	};

	const getBATDModels = () => {
		let modelsString = null;

		if (formData.form.handle === "requestACallback") {
			modelsString = carModel.title;
		} else {
			carModels.forEach((model) => {
				if (modelsString === null) {
					modelsString = `${carModel.title} - ${model.title}`;
				} else {
					modelsString += `, ${carModel.title} - ${model.title}`;
				}
			});
		}

		return modelsString;
	}

	return (
		<FormBuilder
			formData={formData}
			handleSubmit={submitData}
			category={category}
			maxSpan="8"
			appendData={{
				batdModel: getBATDModels(),
			}}
			spec={spec}
		/>
	);
};

const FormHolder = (props) => {
	const {
		category,
		featuredImage,
		close,
		product,
		models = [],
		formData,
		thankYou,
	} = props;

	const [fillForm, setFillForm] = useState("cp");
	const [selectedModels, setSelectedModels] = useState([]);
	const [clicked, setClicked] = useState(0);
	const [formTitle, setFormTitle] = useState("");
	const [enableProductSelect, setEnableProductSelect] = useState(false);

	const [isSubmitting, setIsSubmitting] = useState(false);

	const router = useRouter();

	useEffect(() => {
		if (formData) {
			const formTitle = getFormAttribute(formData, "formTitle");
			const enableProductSelect = getFormAttribute(formData, "enableProductSelect");

			if (formTitle) {
				setFormTitle(formTitle);
			} else {
				setFormTitle(formData.form.name || '');
			}

			if (enableProductSelect) {
				setEnableProductSelect(true);
			}
		}
	},[formData]);

	const toggleSelectedModel = (model) => {
		let index = -1;
		let found = selectedModels.filter((newModel, i) => {
			if (newModel.slug === model.slug) {
				index = i;
			}
			return newModel.slug === model.slug;
		});

		let newSelectedModels = selectedModels;

		if (found.length > 0) {
			//Remove from array
			newSelectedModels.splice(index, 1);
		} else {
			// Add to array
			newSelectedModels.push(model);
		}

		setSelectedModels(newSelectedModels);
		let click = clicked + 1;
		setClicked(click);
	};

	const getThanksSlug = () => {
		var first = window.location.pathname;

		first.indexOf(1);

		first.toLowerCase();

		first = first.split("/")[1];

		return first;
	};

	const submitFormData = () => {
		if (!isEmpty(thankYou)) {
			router.push(thankYou);
		} else {
			router.push("/" + getThanksSlug() + formData.form.returnUrl); //use form return url
		}
	};

	const checkActive = (model) => {
		let found = selectedModels.filter((newModel) => {
			return newModel.slug === model.slug;
		});

		return found.length > 0 ? "active" : "";
	};

	useEffect(() => {
		if (window.pageYOffset > 0) {
			let banner = document.getElementsByClassName("smallBanner");

			if (banner.length === 0) {
				banner = document.getElementsByClassName("banner");
			}

			const height = banner.offsetHeight;
			window.scrollTo(0, height - 64);
		}
	}, [fillForm]);

	if (isSubmitting) {
		return (
			<div className="customContainer formLoader">
				<span>
					<FontAwesomeIcon
						icon={["far", "spinner-third"]}
						spin
					/>
				</span>
			</div>
		);
	}

	if (formData) {
		return (
			<div className="customContainer bookATestDrive">
				<div className="row form">
					<div className="col s12 intro">
						<h2 className="left">
							{formTitle}
						</h2>
						<div
							className="close right"
							onClick={() => {
								close(false);
							}}
						>
							<FontAwesomeIcon icon={["far", "times"]} size={"2x"} />
						</div>
					</div>
				</div>
				{enableProductSelect && models.length > 0 && (
					<div className="row productSelect">
						<div className="col s12 m6 l6">
							<div className="productHolder">
								<div className="img">
									<img
										src={featuredImage ? featuredImage.url : ""}
										alt=""
									/>
								</div>
							</div>
						</div>

						<div className="col s12 m6 l6">
							<div id="productSelectHolder" className="productHolder">
								<div
									id="productSelectTitle"
									className="productSelectTitle"
								>
									<h5>Please select your model</h5>
								</div>
								<div className="models">
									{models.map((model) => {
										return (
											<div
												className={`model ${checkActive(
													model
												)}`}
												key={model.slug}
												onClick={() => {
													toggleSelectedModel(model);
												}}
											>
												{model.title}
											</div>
										);
									})}
								</div>
							</div>
						</div>
					</div>
				)}
				<div className="row form">
					<div className="col s12 m12 l12">
						{/* Form details to be sent from here */}
						<BATDForm
							formTitle={formTitle}
							submitFormData={submitFormData}
							category={category}
							formData={formData}
							carModel={product}
							carModels={selectedModels}
						/>
					</div>
				</div>
			</div>
		);
	}
};

export default FormHolder;
